var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 16 16",
    className: "ml2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "currentColor",
    d: "M8.7589721,9.5 C8.7589721,9.77614237 8.5432876,10 8.25962632,10 L7.49934584,10 C7.22356477,10 7.00000005,9.76806641 7.00000005,9.5 L7.00000005,9 C7.00000005,8.34869385 9.25010007,7.05957031 9.2501,6 C9.25009998,5.652 9.0251,4.75 8.0001,4.75 C6.9791,4.75 6.7881,5.734 6.7551,6 C6.7551,6 5.26889746,6.022 5.26989746,6 C5.26889746,5.06573486 6.0041,3.25 8.0001,3.25 C9.7211,3.25 10.7501,4.648 10.7501,6 C10.7501,7.373 8.7589721,8.60931396 8.7589721,9 L8.7589721,9.5 Z M8.0001,13 C7.4481,13 7.0001,12.552 7.0001,12 C7.0001,11.448 7.4481,11 8.0001,11 C8.5521,11 9.0001,11.448 9.0001,12 C9.0001,12.552 8.5521,13 8.0001,13 M1.0001,8 C1.0001,11.866 4.1341,15 8.0001,15 C11.8661,15 15.0001,11.866 15.0001,8 C15.0001,4.134 11.8661,1 8.0001,1 C4.1341,1 1.0001,4.134 1.0001,8 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.9b24f15d8ce32237a814bd122cde9b6a.svg";
export { ForwardRef as ReactComponent };